import { render, staticRenderFns } from "./fu-dialog.vue?vue&type=template&id=ac524f68&scoped=true"
import script from "./fu-dialog.vue?vue&type=script&lang=js"
export * from "./fu-dialog.vue?vue&type=script&lang=js"
import style0 from "./fu-dialog.vue?vue&type=style&index=0&id=ac524f68&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac524f68",
  null
  
)

export default component.exports